import React from 'react'

import { useRouter } from 'next/router'

import CommonNavbar from '@/components/layouts/common/Navbar'
import { useBreadcrumbItems } from '@/components/opportunity/common/BreadcrumbV2/context'

import type { Breadcrumb } from '@/types/navigation/Navbar'

interface RouteInfo {
  pathname: string
  id?: string
}

function getStaticBreadcrumbsForPath({
  pathname,
}: RouteInfo): Array<Breadcrumb> {
  let breadcrumbs: Breadcrumb[] = []
  if (pathname.startsWith('/sbirs')) {
    breadcrumbs = [{ name: 'SBIR/STTRs', href: '/sbirs/search' }]
  }
  if (pathname.startsWith('/sled-contracts')) {
    breadcrumbs = [
      { name: 'SLED Contract Opportunities', href: '/sled-contracts/search' },
    ]
  }
  if (pathname.startsWith('/dibbs-contracts')) {
    breadcrumbs = [
      { name: 'DIBBS Opportunities', href: '/dibbs-contracts/search' },
    ]
  }
  if (pathname.startsWith('/federal-grants')) {
    breadcrumbs = [{ name: 'Federal Grants', href: '/federal-grants/search' }]
  }
  if (pathname.startsWith('/awards')) {
    breadcrumbs = [{ name: 'Federal Awards', href: '/awards/search' }]
  }
  if (pathname.startsWith('/agencies/personnel')) {
    // TODO: add href when /agencies/personnel/search is built
    breadcrumbs = [{ name: 'Federal Personnel', href: '' }]
  }
  if (pathname.startsWith('/agencies')) {
    if (pathname.includes('usaspending')) {
      breadcrumbs = [{ name: 'Federal Agencies', href: '' }]
    } else {
      // TODO: add href when /agencies/search is built
      breadcrumbs = [{ name: 'Agencies', href: '' }]
    }
  }

  if (breadcrumbs.length > 0) {
    return [{ name: 'Sweetspot', href: '/' }, ...breadcrumbs]
  }

  // Default for federal contracts and other pages
  return [
    { name: 'Sweetspot', href: '/' },
    {
      name: 'Federal Contract Opportunities',
      href: '/federal-contracts/search',
    },
  ]
}

const Navbar: React.FC = () => {
  const router = useRouter()
  const id = typeof router.query.id === 'string' ? router.query.id : undefined
  const dynamicItems = useBreadcrumbItems()

  // Use dynamic items if available, otherwise fall back to static
  const breadcrumbs: Breadcrumb[] =
    dynamicItems.length > 0
      ? dynamicItems.map((item) => ({
          name: item.name,
          href: item.href,
        }))
      : getStaticBreadcrumbsForPath({ pathname: router.pathname, id })

  return <CommonNavbar breadcrumbs={breadcrumbs} />
}

export default Navbar
